export const titles = {
  canais: "Canais",
  extras: "Cursos Extras",
  game: "Seus Games",
  ideias: "Ideias",
  lives: "Lives",
  postagens: "Postagens",
  trilhas: "Trilhas",
  tutoriais: "Biblioteca",
  catalogo: "Catálogo",
  //TODO verificar quando possível
  pesquisa: "Pesquisa",
};

export const keysNav = {
  CANAIS: "canais",
  EXTRAS: "extras",
  GAMES: "game",
  IDEIAS: "ideias",
  LIVES: "lives",
  POSTAGEM: "postagens",
  "REDE SOCIAL": "social",
  DASHBOARD: "dashboard",
  INSCRICAO: "inscricao",
  TRILHAS: "trilhas",
  TUTORIAIS: "tutoriais",
  BASE: "base",
  NOTICIAS: "noticias",
  PROFESSOR: "menu-educador",
  CATALOGO: "catalogo",
  GESTOR: "prateleira",
  CERTIFICACOES: "certificacoes",
  RECOMENDADOS: "recomendados",
  OBRIGATORIOS: "obrigatorios",
  //TODO verificar quando possível
  PESQUISA: "pesquisa",
  GESTAO_PESQUISAS: "pesquisagestor",
};
